import { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export const useSwipeable = (
  onSwipeRight = () => {},
  onSwipeLeft = () => {}
) => {
  useEffect(() => {
    let startPositionX = 0;
    let startPositionY = 0;
    let diffX = 0;
    let diffY = 0;
    let timeStart = 0;
    let timeout = 500;
    let swipeTrashold = 20;

    const onTouchStart = (e: any) => {
      startPositionX = e.touches[0].clientX;
      startPositionY = e.touches[0].clientY;
      timeStart = Date.now();
    };
    document.addEventListener('touchstart', onTouchStart);

    const onTouchMove = (e: any) => {
      diffX = startPositionX - e.touches[0].clientX;
      diffY = startPositionY - e.touches[0].clientY;
    };
    document.addEventListener('touchmove', onTouchMove);

    const onTouchEnd = () => {
      if (
        Date.now() - timeStart > timeout ||
        Math.abs(diffX) < swipeTrashold ||
        Math.abs(diffY) > Math.abs(diffX)
      )
        return;

      if (diffX > 0) {
        onSwipeLeft();
      } else if (diffX < 0) {
        onSwipeRight();
      }
    };
    document.addEventListener('touchend', onTouchEnd);

    return () => {
      document.removeEventListener('touchstart', onTouchStart);
      document.removeEventListener('touchmove', onTouchMove);
      document.removeEventListener('touchends', onTouchEnd);
    };
  }, [onSwipeLeft, onSwipeRight]);
};

const pages = ['/dashboard', '/devices', '/webhooks'];
const getPage = (nextIndex: number) => {
  if (nextIndex >= 0 && nextIndex < pages.length) {
    return pages[nextIndex];
  } else if (nextIndex >= pages.length) {
    return pages[0];
  } else if (nextIndex < 0) {
    return pages[pages.length - 1];
  }
};
export const getNextPage = (path: string) => {
  const nextIndex = pages.indexOf(path) + 1;
  return getPage(nextIndex);
};

export const getPreviousPage = (path: string) => {
  const nextIndex = pages.indexOf(path) - 1;
  return getPage(nextIndex);
};

export const useSwipeableNavigation = () => {
  const history = useHistory();

  const goForward = useCallback(() => {
    const page = getPreviousPage(window.location.pathname);
    if (page) {
      history.push(page);
    }
  }, [history]);

  const goBack = useCallback(() => {
    const page = getNextPage(window.location.pathname);
    if (page) {
      history.push(page);
    }
  }, [history]);

  useSwipeable(goForward, goBack);
};
